import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 680px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalTitle = styled.h2`
  color: #1b3a6b;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
`;

export const SectionTitle = styled.h3`
  color: #1b3a6b;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 -8px;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e8f0f7;
  margin: 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-size: 0.82rem;
  font-weight: 600;
  color: #444;
`;

export const Input = styled.input`
  padding: 9px 12px;
  border: 1.5px solid ${({ $error }) => ($error ? "#e53e3e" : "#d0dce8")};
  border-radius: 7px;
  font-size: 0.88rem;
  color: #222;
  outline: none;
  background: #fff;

  &:focus { border-color: ${({ $error }) => ($error ? "#e53e3e" : "#26A9B6")}; }
  &::placeholder { color: #aaa; }
`;

export const Select = styled.select`
  padding: 9px 12px;
  border: 1.5px solid ${({ $error }) => ($error ? "#e53e3e" : "#d0dce8")};
  border-radius: 7px;
  font-size: 0.88rem;
  color: #222;
  outline: none;
  background: #fff;
  cursor: pointer;

  &:focus { border-color: ${({ $error }) => ($error ? "#e53e3e" : "#26A9B6")}; }
`;

export const Textarea = styled.textarea`
  padding: 9px 12px;
  border: 1.5px solid #d0dce8;
  border-radius: 7px;
  font-size: 0.88rem;
  color: #222;
  outline: none;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;

  &:focus { border-color: #26A9B6; }
  &::placeholder { color: #aaa; }
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: #888;
`;

export const CheckRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #26A9B6;
  cursor: pointer;
`;

export const CheckLabel = styled.label`
  font-size: 0.88rem;
  color: #333;
  cursor: pointer;
`;

export const AvatarGrid = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const AvatarOption = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  border: 3px solid ${({ $selected }) => ($selected ? "#26A9B6" : "transparent")};
  opacity: ${({ $selected }) => ($selected ? 1 : 0.7)};
  transition: opacity 0.15s, border-color 0.15s;

  &:hover { opacity: 1; }
`;

export const ErrorMsg = styled.p`
  color: #e53e3e;
  font-size: 0.82rem;
  margin: 0;
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 4px;
`;

export const CancelButton = styled.button`
  padding: 10px 22px;
  border-radius: 8px;
  border: 1.5px solid #d0dce8;
  background: #fff;
  color: #555;
  font-size: 0.88rem;
  cursor: pointer;

  &:hover { background: #f5f5f5; }
`;

export const SubmitButton = styled.button`
  padding: 10px 22px;
  border-radius: 8px;
  border: none;
  background: #26A9B6;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #1f8f9a; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const AutoField = styled.div`
  padding: 9px 12px;
  border: 1.5px solid #e8f0f7;
  border-radius: 7px;
  font-size: 0.88rem;
  color: #555;
  background: #f8fbfd;
  min-height: 38px;
`;
